module.exports = __webpack_public_path__ + "fonts/sourcesansprolightitalic.79d5772f.ttf";